import React from 'react'
interface Props {
    styleCssImage: string
}
const LogoPaimentFacture: React.FC<Props> = ({styleCssImage}) => {
  return (
    <svg 
    // className={`${styleCssImage} `}
    className={`${styleCssImage} fill-[#38C3FF]`}

    width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="59.9996" height="60" rx="10" 
    //   fill-[#33B0E6]
       />
      <path
        d="M30.7083 44.25H28.197C23.5769 44.25 21.2669 44.25 19.6627 43.153C19.203 42.8387 18.795 42.4659 18.4509 42.046C17.25 40.5805 17.25 38.4703 17.25 34.25V30.75C17.25 26.6756 17.25 24.6385 17.9143 23.0114C18.9823 20.3957 21.2409 18.3325 24.1043 17.3569C25.8855 16.75 28.1156 16.75 32.5758 16.75C35.1245 16.75 36.3988 16.75 37.4165 17.0968C39.0528 17.6543 40.3435 18.8333 40.9537 20.3279C41.3333 21.2577 41.3333 22.4218 41.3333 24.75V28.4375"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.25 30.5C17.25 27.9686 19.3642 25.9167 21.9722 25.9167C22.9154 25.9167 24.0274 26.0771 24.9444 25.8386C25.7592 25.6267 26.3957 25.009 26.614 24.2181C26.8597 23.3281 26.6944 22.2488 26.6944 21.3333C26.6944 18.802 28.8087 16.75 31.4167 16.75"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.75 42.1769C42.0723 43.4191 40.8392 44.25 39.4305 44.25C37.2916 44.25 35.5577 42.3348 35.5577 39.9722V37.5278C35.5577 35.1652 37.2916 33.25 39.4305 33.25C40.8392 33.25 42.0723 34.0809 42.75 35.3231M34.25 38.75H39.8077"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default LogoPaimentFacture
